module.exports = {"330522001":"雉城街道","330522002":"画溪街道","330522003":"太湖街道","330522004":"龙山街道","330522101":"洪桥镇","330522102":"李家巷镇","330522103":"夹浦镇","330522104":"林城镇","330522106":"虹星桥镇","330522108":"小浦镇","330522110":"和平镇","330522111":"泗安镇","330522112":"煤山镇","330522200":"水口乡","330522202":"吕山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330522.json
// module id = 989
// module chunks = 0